import { useEffect, useState } from 'react';

const getIEInfo = () => {
  if (typeof window !== 'object') {
    return false;
  }
  const ua = window.navigator.userAgent;
  const isIe11 = ua.indexOf('Trident/') > 1;
  const isLegacyIe = ua.indexOf('MSIE ') > 1;
  return isLegacyIe || isIe11;
};

const useCheckIe = () => {
  const [isIe, setFlag] = useState(getIEInfo);
  useEffect(() => {
    setFlag(getIEInfo);
  }, []);
  return isIe;
};

export default useCheckIe;
